import './assets/InstallmentDetails.css';const s = {
  "cpw-installment-detials": "_cpw-installment-detials_1d1sv_1"
};
export {
  s
};
//# sourceMappingURL=InstallmentDetails.module-5852dbff.mjs.map
